









































































import { Vue, Component, Watch } from "vue-property-decorator";
import { UserService, SkcServerService, SkcServerOrderService } from "src/services";
import { IServerModel } from "src/model";
import router from '../../router';
import { ServiceType, DurationUnitType } from "src/enums";
import { EnumUtils } from "src/utils";

@Component
export default class ShoppingCart extends Vue
{
     /**
     * 获取平台服务数据
     * @private
     * @return IServerModel
     */
    private dataJson : IServerModel = {
        id: 0,
        imgs: "",
        unitPrice: "",
        name: "",
        durationUnit: null,
        unitDiscountPrice: 0
    };

    /**
     * 年限
     * @protected
     * @returns 
     */
    protected priceData: Array<any> = [
        {id: 0, name: '年', num: 1, checked: true},
        {id: 1, name: '二年', num: 2, checked: false},
        {id: 2, name: '三年', num: 3, checked: false}
    ];

    /**
     * 获取平台服务
     * @private
     * @return SkcServerOrderService
     */
    private _skcServerOrderService: SkcServerOrderService;

     /**
     * 获取或设置用户服务。
     * @protected
     * @returns UserService
     */
    protected get skcServerOrderService(): SkcServerOrderService
    {
        if(!this._skcServerOrderService)
        {
            this._skcServerOrderService = this.$serviceProvier.resolve<SkcServerOrderService>(SkcServerOrderService);
        }

        return this._skcServerOrderService;
    }

     /**
     * 获取平台服务
     * @private
     * @return SkcServerService
     */
    private _skcServerService: SkcServerService;

     /**
     * 获取或设置用户服务。
     * @protected
     * @returns UserService
     */
    protected get skcServerService(): SkcServerService
    {
        if(!this._skcServerService)
        {
            this._skcServerService = this.$serviceProvier.resolve<SkcServerService>(SkcServerService);
        }

        return this._skcServerService;
    }

     /**
     * 获取套餐名称
     * @protected
     */
    protected getDurationUnitTypeName(value: number):string
    {
        return EnumUtils.getEntry(value,DurationUnitType)?.alias || "";
    }

    /**
     * 获取用户服务
     * @private
     * @return UserService
     */
    private _userService: UserService;

    /**
     * 弹框显示
     * @protected
     * @returns 
     */
    protected visible: boolean = false;

    /**
     * 获取或设置用户服务。
     * @protected
     * @returns UserService
     */
    protected get userService(): UserService
    {
        if(!this._userService)
        {
            this._userService = this.$serviceProvier.resolve<UserService>(UserService);
        }

        return this._userService;
    }

    /**
     * 用户信息
     * @protected
     * @type {any}
     */
    protected get userInfo(): any {

        return this.$store.getters["global/userInfo"]
    }

    /**
     * 获取用户信息
     * @private
     * @return Promise<void>
     */
    private async getLoginInfo(): Promise<void>
    {
        try
        {
            let {content: result} = await this.userService.getLoginInfo();
            if(result.data)
            {
                // 存储登入所有信息
                this.$store.dispatch("user/setProfile", result.data);
            }
        } 
        catch(err)
        {
            
            this.$message.error({
                duration: 3,
                content: JSON.stringify(err)
            })
        }
    }


    /**
     * 组件创建钩子。
     * @protected
     * @returns void
     */
    protected created(): void
    {
        this.getServer();
    }

    /**
   * 获取当前版本信息
   * @protected
   * @return void
   */
  protected async getServer(): Promise<void> {
      if (this.$route.query.id) {
          try
            {
            let {content: res} = await this.skcServerService.getSkcServer(parseInt((this.$route.query as any).id));
            if (res && res.data)
            {
                this.dataJson = res.data;
            }
            }
            catch (err)
            {
                this.$message.error({
                    duration: 3,
                    content: err || "服务器错误",
                });
            }
      }  
  }

    /**
     * 下一步
     * @protected
     * @returns void
     */
    protected async nextBtn():Promise<void>
    {
        let data = {serverId: this.dataJson.id, serverNum: this.priceData.filter(res => res.checked)[0].num};
        try
            {
                let {content: res} = await this.skcServerOrderService.skcServerOrder(data);
                if (res && res.data)
                {
                    this.$router.push({name: 'version-paType', query: {id: res.data.id.toString()}})
                }
            }
            catch (err)
            {
                this.$message.error({
                    duration: 3,
                    content: err || "服务器错误",
                });
            }
    }

    /**
   * 注销登录
   * @protected
   * @return void
   */
  protected async logout(): Promise<void> {
    try {
      await this.userService.logout();
    } catch (err) {
      this.$message.error({
        duration: 3,
        content: err || "服务器错误",
      });
    }
  }

    /**
     * 退出登录
     * @protected
     * @returns void
     */
    protected loginOut(): void
    {
        this.$confirm({
            title: "提示",
            content: "是否确定注销登录?",
            okText: "确定",
            cancelText: "取消",
            onOk: async () => {
                return await this.logout()
                .then(() => {
                    setTimeout(() => {
                        localStorage.clear();
                        this.$router.push("/")
                    }, 20);
                })
                .catch(() => {
                    this.$message.error("注销失败");
                });
            },
            onCancel() {},
        });
    }

    /**
     * 改变时间
     * @protected
     * @returns void
     */
    protected changeDataF(item: any): void
    {
        this.priceData.filter(res => res.id != item.id).map(function(ite, index, all){
            ite.checked = false;
        });
        this.priceData.filter(res => res.id == item.id)[0].checked = true;
    }

     /**
     * 返回首页
     * @protected
     * @returns void
     */
    protected gotoIndex(): void
    {
       this.$router.push({name: 'shop'})
    } 
}
